var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "icon-svg full-center", class: "icon-" + _vm.name },
    [
      _vm.iconComponent
        ? _c(
            _vm.iconComponent,
            _vm._g(
              _vm._b(
                {
                  tag: "component",
                  attrs: { size: _vm.size, color: _vm.colorFormatted }
                },
                "component",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
        : _c(
            "v-icon",
            _vm._g(
              _vm._b(
                {
                  style: _vm.vIconStyle,
                  attrs: { color: _vm.vIconColor, size: _vm.size },
                  domProps: { textContent: _vm._s(_vm.name) }
                },
                "v-icon",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }